import { wrapProperty } from '@nuxtjs/composition-api';

const useMatchMedia = wrapProperty('$matchMedia');

export default useMatchMedia;
